module.exports = __webpack_public_path__ + "static/media/logo-full.7765f854.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/layout/Overlay/assets/logo-full.svg
// module id = 985
// module chunks = 0